import { webApi } from '@mi-front/api-clients';
import { DurationForRange } from '@mi-front/ui';
import { FragmentMediaPill } from './FragmentMediaPill';

/**
 * Pill showing fragment duration (from–to). Used as overlay on audio/video card media.
 */
export function FragmentCardDurationPill({ fragment }: { fragment: webApi.FragmentListItemDto }) {
  return (
    <FragmentMediaPill>
      <DurationForRange from={fragment.from} to={fragment.to} unitDisplay="narrow" />
    </FragmentMediaPill>
  );
}
